'use client';

import React, { createContext, useContext } from 'react';

type ScrollOpts = {
  highlight?: boolean;
  highlightMs?: number;
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
};

export type Ctx = {
  register: (id: number, el: HTMLDivElement | null) => void;
  scrollTo: (id: number, opts?: ScrollOpts) => void;
  highlightedId: number | null;
  requestOpenThread: (threadRootId: number) => void;
  openThreadId: number | null;
  clearOpenThread: () => void;
  scrollToWhenReady: (
    id: number,
    opts?: { highlight?: boolean; highlightMs?: number }
  ) => void;
};

const CommentScrollContext = createContext<Ctx | null>(null);

export const useCommentScroll = () => {
  const ctx = useContext(CommentScrollContext);
  if (!ctx) throw new Error('useCommentScroll must be used within provider');
  return ctx;
};

export const useOptionalCommentScroll = () => {
  return useContext(CommentScrollContext);
};


export function CommentScrollProvider({
  value,
  children,
}: {
  value: Ctx;
  children: React.ReactNode;
}) {
  return (
    <CommentScrollContext.Provider value={value}>
      {children}
    </CommentScrollContext.Provider>
  );
}
